import React, { useState } from "react";
import { Box, styled } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import StewartTable from "controls/global/stewart-table";
import TooltipCell from "controls/global/stewart-table/TooltipCell";
import InputSearch from "../../InputSearch";
import { SelectionConfig } from "controls/global/stewart-table/StewartTable";
import { SpecialRiskItem } from "entities/UIModel/SpecialRisk";

interface ViewAllSpecialRisksTableProps {
  specialRiskItems: any[];
  tableSelectedSpecialRisks: any[];
  isNoSpecialRisksEnabled: boolean;
  setTableSelectedSpecialRisks: (specialRisks: any) => void;
}
const TableWrapper = styled(Box)({
  height: "100%",
  maxHeight: "calc(100vh - 380px)",
  overflowY: "auto",
  overflowX: "hidden",
  flex: 1,

  "& .MuiTableContainer-root": {
    overflow: "unset !important",
  },

  "& .MuiTableHead-root": {
    position: "sticky",
    top: 0,
    zIndex: 5,
    background: "#fff",
  },

  "& .MuiTableCell-head": {
    background: "#fff",
  },
});

export default function ViewAllSpecialRisksTable({
  specialRiskItems = [],
  tableSelectedSpecialRisks,
  isNoSpecialRisksEnabled,
  setTableSelectedSpecialRisks,
}: ViewAllSpecialRisksTableProps) {
  const [search, setSearch] = useState<string | null>("");

  const filteredSpecialRiskItems = specialRiskItems.filter((item) =>
    item.ConfigValue.toLowerCase().includes(search?.toLowerCase() || "")
  );

  const handleToggleAllRows = () => {
    if (tableSelectedSpecialRisks.length < specialRiskItems.length) {
      setTableSelectedSpecialRisks(
        specialRiskItems.map((risk) => ({
          id: uuidv4(),
          configCode: risk.ConfigCode,
          integrationKey: risk.IntegrationKey,
          selectedSpecialRisk: risk.ConfigValue,
          uniqueIdentifier: risk?.IntegrationKey,
        }))
      );
    } else {
      setTableSelectedSpecialRisks([]);
    }
  };

  const handleToggleRow = (specialRiskItem: SpecialRiskItem) => {
    setTableSelectedSpecialRisks((prevSpecialRisks: any) => {
      if (
        prevSpecialRisks.some(
          (d: any) => d.configCode === specialRiskItem.ConfigCode
        )
      ) {
        return prevSpecialRisks.filter(
          (d: any) => d.configCode !== specialRiskItem.ConfigCode
        );
      }
      return [
        ...prevSpecialRisks,
        {
          id: uuidv4(),
          configCode: specialRiskItem.ConfigCode,
          integrationKey: specialRiskItem.IntegrationKey,
          selectedSpecialRisk: specialRiskItem.ConfigValue,
          uniqueIdentifier: specialRiskItem?.IntegrationKey,
        },
      ];
    });
  };

  const selectionConfig: SelectionConfig<any> = {
    enabled: true,
    selectedRows: tableSelectedSpecialRisks.map((risk) => risk.integrationKey),
    onToggleAllRows: handleToggleAllRows,
    onToggleRow: handleToggleRow,
    disableCheckboxes: isNoSpecialRisksEnabled,
    isRowSelected: (specialRiskItem: SpecialRiskItem) =>
      tableSelectedSpecialRisks.some(
        (d) => d.integrationKey === specialRiskItem.IntegrationKey
      ),
      sortSelectedOnTop: true,
  };

  const columns: any[] = [
    {
      field: "ConfigValue",
      name: "Special Risks",
      sortable: true,
      width: 500,
      valueGetter: (row: any) => {
        return (
          <Box>
            <TooltipCell title={row.ConfigValue}></TooltipCell>
          </Box>
        );
      },
      actionComponent: () => (
        <InputSearch
          name="specialRisks"
          defaultValue=""
          onChange={(name, value) => {
            setSearch(value);
          }}
        />
      ),
    },
  ];

  return (
    <TableWrapper>
      <StewartTable
        cols={columns}
        rows={filteredSpecialRiskItems || []}
        selectionConfig={selectionConfig}
        rowsPerPage={999999}
        noRowsMessage={[" No Special Risks available "]}
        page={1}
        order="desc"
        onColumnResize={() => {}}
        isStickyHeader
      />
    </TableWrapper>
  );
}
